export default "__VITE_ASSET__e3bbac67__"